const loadingSelector = state => state.loading.isLoading;
export default loadingSelector;